<template>
  <div id="accommodation-service-form">
    <!-- SERVICE -->
    <b-row class="mb-2">
      <b-col cols="12">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Servei</h6>
          </b-col>
          <b-col cols="12">
            <v-select
              v-model="service"
              :options="servicesOptions"
              :reduce="(option) => option.value"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- CHARGABLE -->
    <b-row class="mb-2">
      <b-col cols="12" sm="6" class="mb-1 mb-sm-0">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>És obligatori?</h6>
          </b-col>
          <b-col cols="12">
            <b-form-checkbox v-model="mandatory" switch inline />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="6">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Cobrem nosaltres?</h6>
          </b-col>
          <b-col cols="12">
            <b-form-checkbox
              v-model="chargable"
              :disabled="paymentTime === 'PROVIDER'"
              switch
              inline
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- PAYMENT FREQUENCY & TIME -->
    <b-row class="mb-2">
      <b-col cols="12" sm="6" class="mb-2 mb-sm-0">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Freqüència de pagament</h6>
          </b-col>
          <b-col cols="12">
            <v-select
              v-model="paymentFrequency"
              :options="paymentFrequencyOptions"
              :reduce="(option) => option.value"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="6">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Moment de pagament</h6>
          </b-col>
          <b-col cols="12">
            <v-select
              v-model="paymentTime"
              :options="paymentTimeOptions"
              :reduce="(option) => option.value"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- PAYMENT METHODS -->
    <b-row class="mb-1">
      <b-col cols="12" class="mb-25">
        <h6>Mètodes de pagament</h6>
      </b-col>
      <b-col
        v-for="option in paymentMethodOptions"
        :key="`payment-method-${option.value}-option`"
        cols="12"
        sm="6"
      >
        <b-form-checkbox
          v-model="paymentMethods"
          class="mb-1"
          :value="option.value"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-col>
    </b-row>

    <!-- INVOICE HOLDER & VAT PERCENTAGE -->
    <b-row class="mb-2">
      <b-col cols="12" sm="6">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Emissor de la factura <small>(opcional)</small></h6>
          </b-col>
          <b-col cols="12">
            <v-select
              v-model="invoiceHolder"
              :options="invoiceHolderOptions"
              :reduce="(option) => option.value"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="6">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>% I.V.A.</h6>
          </b-col>
          <b-col cols="12">
            <v-select
              v-model="vatPercentage"
              :options="vatPercentageOptions"
              :reduce="(option) => option.value"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- PVP & COST PRICE -->
    <b-row class="mb-2">
      <b-col cols="12" sm="6" class="mb-1 mb-sm-0">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>PVP <small>(opcional)</small></h6>
          </b-col>
          <b-col cols="12">
            <b-input-group class="input-group-merge" append="€">
              <b-form-input v-model="pvp" type="number" />
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="6">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Preu de cost <small>(opcional)</small></h6>
          </b-col>
          <b-col cols="12">
            <b-input-group class="input-group-merge" append="€">
              <b-form-input v-model="costPrice" type="number" />
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- COMISSION & AMOUNT -->
    <b-row class="mb-2">
      <b-col cols="12" sm="6" class="mb-1 mb-sm-0">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Comissió <small>(opcional)</small></h6>
          </b-col>
          <b-col cols="12">
            <b-input-group class="input-group-merge" append="%">
              <b-form-input v-model="commissionPercentage" type="number" />
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="6">
        <b-row>
          <b-col cols="12" class="mb-25">
            <h6>Serveis disponibles <small>(opcional)</small></h6>
          </b-col>
          <b-col cols="12">
            <b-form-spinbutton v-model="amount" min="1" max="100" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- BUTTONS -->
    <b-row class="mb-1 d-flex justify-content-between justify-content-sm-end">
      <b-col cols="6" sm="auto">
        <b-button block variant="light" @click="cancel"> Cancel·la </b-button>
      </b-col>
      <b-col cols="6" sm="auto">
        <b-button block variant="primary" @click="saveAccommodationService">
          Guarda
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BInputGroup,
  BFormInput,
  BFormCheckbox,
  BFormSpinbutton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import {
  paymentFrequencyOptions,
  paymentTimeOptions,
  paymentMethodOptions,
  invoiceHolderOptions,
  vatPercentageOptions,
} from "@/utils/select-options";
import { getServiceName, getInitialServiceProps } from "@/utils/methods";

export default {
  components: {
    BRow,
    BCol,
    vSelect,
    BInputGroup,
    BFormInput,
    BFormCheckbox,
    BFormSpinbutton,
    BButton,
  },
  props: {
    accommodationService: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      service: null,
      pvp: null,
      costPrice: null,
      amount: null,
      mandatory: false,
      chargable: false,
      paymentFrequency: null,
      paymentTime: null,
      paymentMethods: ["CREDIT_CARD", "BANK_TRANSFER", "BIZUM"],
      commissionPercentage: null,
      invoiceHolder: null,
      vatPercentage: null,
      paymentFrequencyOptions,
      paymentTimeOptions,
      paymentMethodOptions,
      invoiceHolderOptions,
      vatPercentageOptions,
    };
  },
  computed: {
    accommodation() {
      return this.$store.getters["accommodation/accommodation"];
    },
    services() {
      return this.$store.getters["services/services"];
    },
    servicesOptions() {
      if (!this.services.length) return [];

      const options = [];

      this.services
        .filter((service) => service.code !== "OTHER")
        .sort((a, b) => {
          if (a.description > b.description) return 1;
          if (b.description > a.description) return -1;
          return 0;
        })
        .forEach((service) => {
          options.push({
            label: getServiceName(service, this.$i18n.locale),
            value: service["@id"],
          });
        });

      const otherService = this.services.find(
        (service) => service.code === "OTHER"
      );

      if (otherService) {
        options.push({
          label: getServiceName(otherService, this.$i18n.locale),
          value: otherService["@id"],
        });
      }

      return options;
    },
  },
  watch: {
    paymentTime(value) {
      if (value === "PROVIDER") this.chargable = false;
    },
    invoiceHolder(value) {
      if (!value) this.invoiceHolder = null;
    },
    service(service) {
      if (this.accommodationService) return;

      const selectedService = this.services.find((s) => s["@id"] === service);
      if (!selectedService) return;

      this.initService(selectedService.code);
    },
  },
  created() {
    if (this.accommodationService) this.initForm();
  },
  methods: {
    initForm() {
      if (!this.accommodationService) return;
      this.service = this.accommodationService.service["@id"];
      this.pvp = this.accommodationService.price / 100;
      this.costPrice = this.accommodationService.costPrice / 100;
      this.amount = this.accommodationService.amount;
      this.mandatory = this.accommodationService.mandatory || false;
      this.paymentFrequency = this.accommodationService.paymentFrequency;
      this.paymentTime = this.accommodationService.paymentTime;
      this.paymentMethods = this.accommodationService.paymentMethods;
      this.chargable = this.accommodationService.chargable || false;
      this.commissionPercentage =
        this.accommodationService.commissionPercentage;
      this.invoiceHolder = this.accommodationService.invoiceHolder;
      this.vatPercentage = this.accommodationService.vatPercentage;
    },
    initService(serviceCode) {
      const {
        mandatory,
        chargable,
        paymentFrequency,
        paymentTime,
        paymentMethods,
        pvp,
        costPrice,
        commissionPercentage,
        amount,
        invoiceHolder,
        vatPercentage,
      } = getInitialServiceProps(serviceCode) || {};

      this.mandatory = mandatory || false;
      this.chargable = chargable || false;
      this.paymentFrequency = paymentFrequency || null;
      this.paymentTime = paymentTime || null;
      this.paymentMethods = paymentMethods || [];
      this.pvp = pvp || null;
      this.costPrice = costPrice || null;
      this.commissionPercentage = commissionPercentage || null;
      this.amount = amount || null;
      this.invoiceHolder = invoiceHolder || null;
      this.vatPercentage = vatPercentage || null;
    },
    resetForm() {
      this.service = null;
      this.pvp = null;
      this.costPrice = null;
      this.amount = null;
      this.mandatory = false;
      this.paymentFrequency = null;
      this.paymentTime = null;
      this.paymentMethods = [];
      this.chargable = false;
      this.commissionPercentage = null;
      this.invoiceHolder = null;
      this.vatPercentage = null;
    },
    cancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    saveAccommodationService() {
      if (this.accommodationService) this.updateAccommodationService();
      else this.createAccommodationService();
    },
    createAccommodationService() {
      this.$store.dispatch("app/setLoading", true);
      setTimeout(() => {
        this.$store
          .dispatch("accommodation/addService", {
            accommodation: this.accommodation["@id"],
            service: this.service,
            price: this.pvp ? Math.round(this.pvp * 100) : null,
            costPrice: this.costPrice ? Math.round(this.costPrice * 100) : null,
            amount: parseInt(this.amount, 10),
            mandatory: this.mandatory || false,
            paymentFrequency: this.paymentFrequency,
            paymentTime: this.paymentTime,
            paymentMethods: this.paymentMethods,
            chargable: this.chargable || false,
            invoiceHolder: this.invoiceHolder,
            commissionPercentage: isNaN(parseFloat(this.commissionPercentage))
              ? null
              : parseFloat(this.commissionPercentage),
            vatPercentage: isNaN(parseFloat(this.vatPercentage))
              ? null
              : parseFloat(this.vatPercentage),
          })
          .then(() => this.$emit("service-added"))
          .catch(() => {
            this.$emit("add-service-error");
            // TODO: Log error in Sentry? Only if is not logged in the store
          })
          .finally(() => this.$store.dispatch("app/setLoading", false));
      }, 100);
    },
    updateAccommodationService() {
      this.$store.dispatch("app/setLoading", true);
      setTimeout(() => {
        this.$store
          .dispatch("accommodation/updateService", {
            uuid: this.accommodationService.uuid,
            service: this.service,
            price: this.pvp ? Math.round(this.pvp * 100) : null,
            costPrice: this.costPrice ? Math.round(this.costPrice * 100) : null,
            amount: parseInt(this.amount, 10),
            mandatory: this.mandatory || false,
            paymentFrequency: this.paymentFrequency,
            paymentTime: this.paymentTime,
            paymentMethods: this.paymentMethods,
            chargable: this.chargable || false,
            invoiceHolder: this.invoiceHolder,
            commissionPercentage: isNaN(parseFloat(this.commissionPercentage))
              ? null
              : parseFloat(this.commissionPercentage),
            vatPercentage: isNaN(parseFloat(this.vatPercentage))
              ? null
              : parseFloat(this.vatPercentage),
          })
          .then(() => this.$emit("service-edited"))
          .catch(() => {
            this.$emit("edit-service-error");
            // TODO: Log error in Sentry? Only if is not logged in the store
          })
          .finally(() => this.$store.dispatch("app/setLoading", false));
      }, 100);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
